import { ConfigurationService } from "./../services/configuration.service";
import { Injectable } from "@angular/core";

@Injectable()
export class MenuService {
  menuItems: Array<any>;

  sectionName = "voiceMenu";
  role: string = '';

  constructor(private configurationService: ConfigurationService) {
    this.menuItems = [];
  }

  addMenu(
    items: Array<{
      text: string;
      heading?: boolean;
      link?: string; // internal route links
      elink?: string; // used only for external links
      target?: string; // anchor target="_blank|_self|_parent|_top|framename"
      icon?: string;
      alert?: string;
      submenu?: Array<any>;
      privilegeName?: string; // Aggiunta di un privilegio
    }>,
    role: string
  ) {
    this.menuItems = [];
    this.role = role;

    this.menuItems = [...items];

    for (let idx = this.menuItems.length - 1; idx >= 0; idx--) {
      const menuVoice = this.menuItems[idx];
      if (!this.hasPrivilege(menuVoice.privilegeName)) {
        this.menuItems.splice(idx, 1);
      } else {
        this.checkSubmenu(menuVoice);
      }
    }
  }

  checkSubmenu(menuItem: any) {
    if (menuItem.submenu == null) {
      return;
    }
    for (let idx = menuItem.submenu.length - 1; idx >= 0; idx--) {
      const item = menuItem.submenu[idx];
      if (!this.hasPrivilege(item.privilegeName)) {
        if (menuItem.submenu) {
          menuItem.submenu.splice(idx, 1);
        }
      } else {
        this.checkSubmenu(item);
      }
    }
  }

  hasPrivilege(privilegeName: string): boolean {
    return this.configurationService.userHasPrivilege(this.role, this.sectionName, privilegeName);
  }

  /* FIXME: da eliminare */
  manageSubMenu(clonedItem: any, originalItem: any): any {
    clonedItem.submenu = [];
    for (const item of originalItem.submenu) {
      if (item.privilegeName != null) {
        if (this.configurationService.userHasPrivilege(this.role, this.sectionName, item.privilegeName)) {
          clonedItem.submenu.push(item);
          if (item.submenu != null) {
            for (const subItem of item.submenu) {
              if (this.configurationService.userHasPrivilege(this.role, this.sectionName, subItem.privilegeName)) {
                clonedItem.submenu.push(subItem);
              }
            }
          }
        }
      } else {
        clonedItem.submenu.push(item);
      }
    }

    return clonedItem;
  }

  getMenu() {
    return this.menuItems;
  }
}
